import { postRequest } from '../helpers/request';

export async function apiGetRiskCenterOverview(options) {
  return postRequest('/risk_center/api/get_overview/', options);
}

export async function apiGetRiskCenterScenarios(options) {
  return postRequest('/risk_center/api/get_scenarios/', options);
}
